'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "ActionMenu": "Polaris-ActionMenu"
};

exports.default = styles;
